// Проф
let doctor_item = [
    {
        id : 1,
        images : 'doctor-no-img.png',
        name : 'Светлана ',
        surname : 'Варнавина',
        middleName : 'Сергеевна',
        profile : 'Медицинская сестра по массажу',
        prof : 'Хирург'
    },
    {
        id : 2,
        images : 'buyalskaya-aleksandra-vladimirovna.png',
        name : 'Светлана',
        surname : 'Донцова ',
        middleName : 'Алексеевна',
        profile : 'Врач УЗ-диагностики высшей категории',
        prof : ''
    },
    {
        id : 3,
        images : 'cheremnykh.png',
        name : 'Анна',
        surname : 'Кара',
        middleName : 'Семеновна',
        profile : 'Хирург',
        prof : 'Хирург'
    },
    {
        id : 4,
        images : 'doctor1.png',
        name : 'Людмила',
        surname : 'Докулина',
        middleName : 'Николаевна',
        profile : 'Врач травматолог-ортопед высшей категории',
        prof : 'Травматолог'
    },
    {
        id : 5,
        images : 'edinova-mariya-valerievna.png',
        name : 'Алла',
        surname : 'Депутатова',
        middleName : 'Юрьевна',
        profile : 'Врач физиотерапевт высшей категории',
        prof : ''
    },
    {
        id : 6,
        images : 'golubeva.png',
        name : 'Ирина',
        surname : 'Карпова',
        middleName : 'Юрьевна',
        profile : 'Логопед',
        prof : 'Логопед'
    },
    {
        id : 7,
        images : 'hakimova.png',
        name : 'Ольга',
        surname : 'Черноусова',
        middleName : 'Александровна',
        profile : 'Врач-невролог',
        prof : 'Невролог'
    },
    {
        id : 8,
        images : 'doctor-no-img.png',
        name : 'Елена',
        surname : 'Яцышина',
        middleName : 'Владимировна',
        profile : 'Врач-невролог, кондидат медицинских наук',
        prof : 'Невролог'
    },
    {
        id : 9,
        images : 'kindyalova.png',
        name : 'Марина',
        surname : 'Бордова',
        middleName : 'Львовна',
        profile : 'Невролог. психоневролог',
        prof : 'Невролог'
    },
    {
        id : 10,
        images : 'doctor-no-img.png',
        name : 'Виктор',
        surname : 'Николайчук',
        middleName : 'Андреевич',
        profile : 'Детский хирург высшей категории',
        prof : 'Хирург'
    },
    {
        id : 11,
        images : 'ledyaeva.png',
        name : 'Елена',
        surname : 'Донцова',
        middleName : 'Владимировна',
        profile : 'Врач детский эндокринолог',
        prof : 'Эндокринолог'
    },
    {
        id : 12,
        images : 'rykova-aleksandra-yurevna.png',
        name : 'Виктория',
        surname : 'Старкова',
        middleName : 'Анатольевна',
        profile : 'Врач детский эндокринолог',
        prof : 'Эндокринолог'
    },
    {
        id : 13,
        images : 'sviridenko.png',
        name : 'Елена',
        surname : 'Бодрова',
        middleName : 'Николаевна',
        profile : 'Невролог',
        prof : 'Невролог'
    },
    {
        id : 14,
        images : 'urtenova.png',
        name : 'Виктория',
        surname : 'Старченкова',
        middleName : 'Сергеевна',
        profile : 'Логопед',
        prof : 'Логопед'
    },
    {
        id : 15,
        images : 'yanchiy.png',
        name : 'Алина',
        surname : 'Шатковская',
        middleName : 'Анатольевна',
        profile : 'Логопед',
        prof : 'Логопед'
    },
];

export default doctor_item;